/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchInterviewUsers } from "./InterviewUsersApi";

const initialState: any = {
  loading: {
    fetchInterviewUsers: false,
  },
  req_success: {
    fetchInterviewUsers: false,
  },
  interviewUsers: [],
  total: 0,
  page: 1,
  limit: 10,
  totalPages: 1,
  stats: {
    totalUsers: 0,
    activeUsers: 0,
    totalAvgPerformance: 0,
    totalInterviews: 0,
  },
};

const InterviewUsersSlice = createSlice({
  name: "interviewUsers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // FETCH INTERVIEW USERS
    builder.addCase(fetchInterviewUsers.pending, (state) => {
      state.loading.fetchInterviewUsers = true;
      state.req_success.fetchInterviewUsers = false;
    });
    builder.addCase(
      fetchInterviewUsers.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.fetchInterviewUsers = false;
        state.req_success.fetchInterviewUsers = true;
        state.interviewUsers = payload?.data || [];
        state.total = payload?.total || 0;
        state.page = payload?.page || 1;
        state.limit = payload?.limit || 10;
        state.totalPages = payload?.totalPages || 1;
        state.stats = payload?.stats || {
          totalUsers: 0,
          activeUsers: 0,
          totalAvgPerformance: 0,
          totalInterviews: 0,
        };
      }
    );
    builder.addCase(fetchInterviewUsers.rejected, (state) => {
      state.loading.fetchInterviewUsers = false;
      state.req_success.fetchInterviewUsers = false;
    });
  },
});

export default InterviewUsersSlice.reducer;

